import { IconBookmark, IconBuildings, IconInfo, IconPencil, IconShare, IconTools } from '@assets/images/icon';
import { IconFacetime, IconTopology } from '@assets/images/main';
import { cameraEdge, camreaServer } from '@assets/images/main/camera';
import { IconCctvOff } from '@assets/images/main/icon';

export default {
  a: [
    { text: 'Product Overview', icon: IconInfo },
    { text: 'Processing Architecture', icon: IconTopology },
    { text: 'Video Input Method', icon: IconFacetime },
    { text: 'Supported Cameras', icon: IconCctvOff },
    { text: 'Installation Method', icon: IconTools },
    { text: 'Recommended Spaces', icon: IconBuildings },
    { text: 'Optimal Environment', icon: IconBookmark },
    { text: 'Key Features', icon: IconPencil },
    { text: 'External Integration', icon: IconShare },
  ],

  b: [
    { text: 'AI Analysis and ORBRO OS Built into a Single Device' },
    { text: 'Operates Independently as an Edge Terminal (Includes ORBRO OS)' },
    { text: 'Network Video Input via RTSP / ONVIF' },
    { text: 'Up to 2 Cameras' },
    { text: 'Easy Setup with Just Power and Camera Connection' },
    { text: 'Entryways, Small Indoor Spaces, Compact Sites' },
    { text: 'Sites Requiring Quick Deployment and Core Features Without Server' },
    { text: 'Single-Device Operation, Low-Cost Setup' },
    { text: 'Basic API Support (Limited Integration)' },
  ],

  c: [
    { text: 'High-Performance Server-Based AI Video Analysis System' },
    { text: 'Integrated Operation with AI Server and ORBRO Server' },
    { text: 'Network Video Input via RTSP / ONVIF' },
    { text: 'Supports 6+ Cameras (Expandable with Server Scaling)' },
    { text: 'Server Room / Control Center–Based Network Architecture' },
    { text: 'Large Hospitals, Logistics Centers, Public Institutions' },
    { text: 'For Medium/Large Facilities Requiring Multi-Channel Analysis' },
    { text: 'Fully Integrated with Advanced ORBRO OS Features: SOP, Heatmap, Zone' },
    { text: 'Full API Support (Real-Time Events, Locations, Situational Data)' },
  ],

  spec: [
    {},

    {
      image: cameraEdge,
      link: '/camera/edge',
      title: 'ORBRO Edge AI',
      desc: '',
    },

    {
      image: camreaServer,
      link: '/camera/server',
      title: 'ORBRO AI Server',
      desc: '',
    },
  ],
};
